import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
var UserSingleNeutralSvg = function UserSingleNeutralSvg() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2a5.631 5.631 0 1 0 0 11.262A5.631 5.631 0 0 0 12 2M9.117 4.748a4.078 4.078 0 1 1 5.766 5.766 4.078 4.078 0 0 1-5.766-5.766M12 14.621a20.1 20.1 0 0 0-9.593 2.42l-.407.22V22h20v-4.739l-.407-.22A20.1 20.1 0 0 0 12 14.621m-8.447 5.826v-2.253A18.55 18.55 0 0 1 12 16.174H12a18.55 18.55 0 0 1 8.446 2.02v2.253z",
      clipRule: "evenodd"
    })
  });
};
export var UserSingleNeutral = function UserSingleNeutral(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: UserSingleNeutralSvg
  }));
};